import { IOfferingSearchSortEnum } from '@r-client/data/graphql-types';

import { ISortByValue } from '../components/growth-stage-ventures/sort-by-menu/types';

/**
 * A total `Record` rather than a lookup with a fallback: adding a menu option
 * without deciding its wire value then fails to compile instead of silently
 * defaulting.
 */
const SORT_ENUM_BY_VALUE: Record<ISortByValue, IOfferingSearchSortEnum> = {
  trending: IOfferingSearchSortEnum.Trending,
  newest: IOfferingSearchSortEnum.RecentlyLaunched,
  'closing-soon': IOfferingSearchSortEnum.ClosingSoon,
  'most-funded': IOfferingSearchSortEnum.MostFunded,
};

export const toOfferingSearchSort = (
  value: ISortByValue
): IOfferingSearchSortEnum => SORT_ENUM_BY_VALUE[value];
